import { ToolCardSkeleton } from "./ToolCardSkeleton";

export function ToolsSkeleton() {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
            {[...Array(6)].map((_, i) => (
                <ToolCardSkeleton key={i} />
            ))}
        </div>
    );
}
